module.exports = __webpack_public_path__ + "images/floor-plan-b012a0e8475b58ffae38e06c99fc2952.jpg";